import React, { useState } from "react";
import { useField, useFormikContext } from "formik";
import "./Input.css";
import { Dropdown } from "../"; // Update path if needed

const Input = ({
  label,
  name,
  number,
  placeholder,
  type = "text",
  options = [],
  ...props
}) => {
  const [field, meta] = useField(name);
  const { setFieldValue } = useFormikContext();
  const [isTyping, setIsTyping] = useState(false);

  const handleChange = (e) => {
    field.onChange(e);
    setIsTyping(e.target.value.trim().length > 0);
  };

  return (
    <div
      className={`input-field-box ${
        meta.touched && meta.error ? "input-field-box-error" : ""
      }`}
    >
      <div className="number">
        <span>{number}</span>
      </div>

      <div className={`question-answer-div ${isTyping ? "" : "is-typing"}`}>
        <label htmlFor={name}>{label}</label>

        {type === "selection" ? (
          <div
            className={`dropdown-wrapper ${
              meta.touched && meta.error ? "input-field-box-error" : ""
            }`}
          >
            <Dropdown
              values={options}
              selectedValue={field.value}
              onSelectValue={(val) => {
                setFieldValue(name, val);
                setIsTyping(true);
              }}
            />
          </div>
        ) : type === "textarea" ? (
          <textarea
            {...field}
            {...props}
            id={name}
            rows="5"
            className="input-field"
            onChange={handleChange}
            placeholder={placeholder}
          />
        ) : (
          <input
            {...field}
            {...props}
            id={name}
            className="input-field"
            onChange={handleChange}
            placeholder={placeholder}
          />
        )}

        {meta.touched && meta.error ? (
          <div className="input-error">{meta.error}</div>
        ) : null}
      </div>
    </div>
  );
};

export default Input;
